/**
 * 用户行为埋点信息
 * https://www.yuque.com/wtdc/backend/bo37eq#wFFN
 */
import  spider from '@wtdc/spider/umd/web_spider.min';
import { BASE_API_ROOT, TRACK_ENTRY_TYPE } from '@/config';
import { appTypeList } from '@/utils/application';
import Utils from '@/utils/utils';
import Locator from '@/utils/locator';

const FROM_TYPES = {
  H5: 'rays_h5',
  OFFICIAL: 'official',
  WEAPP: 'weapp',
  DIGITAL: 'digital',
  SHARE: 'share'
};
/** 来源：改这里的逻辑需要通知数据人员 @段宏超 */
function getReferer() {
  const { shareFlag, source_type, clickSource, _oId, miniOfficialAccountsId, rayh5Url } = Locator.query;
  // 来源： referer: {}
  // 1. 公众号消息  source_type=QRCODE
  // 2. 上书H5   rayh5Url=
  // 3. 小睿伴学、伴学乐园： platform 小程序
  // 4. 数字人  clickSource=digital
  // 5. 分享 shareFlag=
  let fromType = FROM_TYPES.H5;
  if(source_type === 'QRCODE') fromType = FROM_TYPES.OFFICIAL;
  if(rayh5Url) fromType = FROM_TYPES.H5;
  if(Utils.isWeAppEnv()) fromType = FROM_TYPES.WEAPP;
  if(_oId) {
    fromType = source_type === 'QRCODE' ? FROM_TYPES.OFFICIAL : FROM_TYPES.H5;
    if(rayh5Url) fromType = FROM_TYPES.H5;
  }
  /**
   * 兜底处理url里面clickSource存在多个的问题(服务端可能重复拼clickSource)
   */
  if(clickSource && /^(digital,*)+$/.test(Array.prototype.join.call(clickSource, ''))) fromType = FROM_TYPES.DIGITAL;
  // if(clickSource === 'digital') fromType = FROM_TYPES.DIGITAL;
  if(shareFlag) fromType = FROM_TYPES.SHARE;
  return JSON.stringify(Utils.searchAssign({
    off_id: miniOfficialAccountsId,
    from_type: fromType
  }));
}
let referer = '';

const getDynamicContent = () => {
  if(!referer) {
    referer = getReferer();
  }
  const contentParams = {
    contentExtra: {
      referer: referer
    }
  };
  const activePathItem = appTypeList.find(v => window.location.pathname === v.url);
  if(activePathItem) {
    contentParams.appId = spider.appList.find(v => v.typeCode === activePathItem.typeCode)?.traceAppId;
    contentParams.adviserId = 1;
  }
  return contentParams;
};

spider.setPara({
  dynamicFn: {
    getDynamicContent: getDynamicContent
  },
  url: BASE_API_ROOT + '/commoncenter/v1.0/user/track/report',
  entry: {
    entryType: TRACK_ENTRY_TYPE,
    entryVersion: '1.0.0'
  }
});

export default spider;
